import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter, Router, Routes, Route, Link, useNavigate} from "react-router-dom";
import App from "./App"; // <-- "/src/App.jsx"

const rootElement = document.getElementById("root");
const root = createRoot(rootElement);

root.render(
    <App />
);


